export default __webpack_public_path__ + "b82dcfdce4531e1e9614a9636eb67552.webp";